export function commentNavID(linkType: string, linkID?: string | number): string {
  return `cm-${linkType}-${linkID}`;
}

export function displayName(protocol: {name?: string | null}): string {
  return protocol.name || 'Untitled';
}
